import { ref } from 'vue'
import { fetchCreditBalance } from '@/api/credits'
import type { CreditBalance } from '@/types/newsletter'

export function useCreditBalance(organisationId: number) {
  const balance = ref<CreditBalance | null>(null)
  const loading = ref<boolean>(false)
  const error = ref<string | null>(null)

  async function refresh(): Promise<void> {
    loading.value = true
    error.value = null
    try {
      balance.value = await fetchCreditBalance(organisationId)
    } catch {
      // Silent failure — chip shows last known value or placeholder
      error.value = 'Could not load credit balance.'
    } finally {
      loading.value = false
    }
  }

  return { balance, loading, error, refresh }
}
